import { generateTypes } from 'reducers/utils/HttpReducerHelper';

export const fundingReportsList = generateTypes('FUNDING_REPORT', 'LIST');
